import { FontSizeData_fontType } from './decoration_fontsize.enums.js';
/* eslint-disable */
export interface FontSizeData {
  /** The units used for the font size. */
  unit: FontSizeData_fontType;
  /** Font size value. */
  value?: number;
}

export function fontSizeData_fontTypeFromJSON(object: any): FontSizeData_fontType {
  switch (object) {
    case 0:
    case 'PX':
      return FontSizeData_fontType.PX;
    case 1:
    case 'EM':
      return FontSizeData_fontType.EM;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return FontSizeData_fontType.UNRECOGNIZED;
  }
}

export function fontSizeData_fontTypeToJSON(object: FontSizeData_fontType): string {
  switch (object) {
    case FontSizeData_fontType.PX:
      return 'PX';
    case FontSizeData_fontType.EM:
      return 'EM';
    default:
      return 'UNKNOWN';
  }
}

const baseFontSizeData: object = { unit: FontSizeData_fontType.PX };

export const FontSizeData = {
  fromJSON(object: any): FontSizeData {
    const message = { ...baseFontSizeData } as FontSizeData;
    message.unit =
      object.unit !== undefined && object.unit !== null
        ? fontSizeData_fontTypeFromJSON(object.unit)
        : FontSizeData_fontType.PX;
    message.value =
      object.value !== undefined && object.value !== null ? Number(object.value) : undefined;
    return message;
  },

  toJSON(message: FontSizeData): unknown {
    const obj: any = {};
    message.unit !== undefined && (obj.unit = fontSizeData_fontTypeToJSON(message.unit));
    message.value !== undefined && (obj.value = message.value);
    return obj;
  },
};
